import { Component, Input } from '@angular/core';

import { IonSpinner } from '@ionic/angular/standalone';

@Component({
    selector: 'lib-loading-spinner',
    standalone: true,
    imports: [IonSpinner],
    templateUrl: './loading-spinner.component.html',
    styleUrl: './loading-spinner.component.css'
})
export class LoadingSpinnerComponent {
    @Input() color: string = 'var(--ion-color-primary)';
    @Input() size: string = '';
}
